import React from 'react';

export type Option = {
  value: string;
  label: string;
  description?: string;
  start?: React.ReactNode;
  hasBottomSeparator?: boolean;
  children?: Option[];
  selectChildrenOnly?: boolean;
};

export enum Size {
  ExtraSmall = 'extra-small',
  Small = 'small',
  Medium = 'medium',
}
